import { B as p } from "./chunk-BaseElement-BuXbltG-.js";
import { x as a } from "./chunk-lit-element-CNHURX5C.js";
import { t as v } from "./chunk-custom-element-ttkHUa8w.js";
import { n as c } from "./chunk-property-Baio2yOX.js";
var f = Object.defineProperty, u = Object.getOwnPropertyDescriptor, m = (t, r, o, s) => {
  for (var e = s > 1 ? void 0 : s ? u(r, o) : r, n = t.length - 1, i; n >= 0; n--)
    (i = t[n]) && (e = (s ? i(r, o, e) : i(e)) || e);
  return s && e && f(r, o, e), e;
};
let l = class extends p {
  handleClick() {
    const t = new CustomEvent(this.eventName, {
      bubbles: !0,
      composed: !0
    });
    this.dispatchEvent(t);
  }
  render() {
    return a` <slot @click=${this.handleClick}></slot> `;
  }
};
m([
  c({ type: String, attribute: "event-name" })
], l.prototype, "eventName", 2);
l = m([
  v("custom-trigger")
], l);
export {
  l as FiltersDrawer
};
